import { defineMessages } from 'react-intl';

const messages = defineMessages({
  modalTitle: {
    id: 'App.ConvertToApplicantModal.modalTitle',
    defaultMessage: 'Convert to Applicant',
  },
  caption: {
    id: 'App.ConvertToApplicantModal.caption',
    defaultMessage:
      'Provide the required details below to convert this prospect to an applicant',
  },
  missingFields: {
    id: 'App.ConvertToApplicantModal.missingFields',
    defaultMessage: 'Complete these required fields to convert: {fields}',
  },
  editModalTitle: {
    id: 'App.ConvertToApplicantModal.editModalTitle',
    defaultMessage: 'Edit Waitlist',
  },
  editCaption: {
    id: 'App.ConvertToApplicantModal.editCaption',
    defaultMessage: 'Review and update the waitlist details below',
  },
  editMissingFields: {
    id: 'App.ConvertToApplicantModal.editMissingFields',
    defaultMessage: 'Complete these required fields to save: {fields}',
  },
  addModalTitle: {
    id: 'App.ConvertToApplicantModal.addModalTitle',
    defaultMessage: 'Add to Waitlist',
  },
  addCaption: {
    id: 'App.ConvertToApplicantModal.addCaption',
    defaultMessage:
      'Provide the waitlist details below to add this applicant to the waitlist',
  },
  addMissingFields: {
    id: 'App.ConvertToApplicantModal.addMissingFields',
    defaultMessage:
      'Complete these required fields to add to the waitlist: {fields}',
  },
  addSubmitLabel: {
    id: 'App.ConvertToApplicantModal.addSubmitLabel',
    defaultMessage: 'Add to Waitlist',
  },
  // Section labels. Each one titles both the nav item and the section card.
  income: {
    id: 'App.ConvertToApplicantModal.income',
    defaultMessage: 'Income',
  },
  household: {
    id: 'App.ConvertToApplicantModal.household',
    defaultMessage: 'Household',
  },
  primaryApplicant: {
    id: 'App.ConvertToApplicantModal.primaryApplicant',
    defaultMessage: 'Primary Applicant',
  },
  unitsAndPreferences: {
    id: 'App.ConvertToApplicantModal.unitsAndPreferences',
    defaultMessage: 'Units & Preferences',
  },
  feesAndDeposits: {
    id: 'App.ConvertToApplicantModal.feesAndDeposits',
    defaultMessage: 'Fees & Deposits',
  },
  // Income section
  householdAnnualIncome: {
    id: 'App.ConvertToApplicantModal.householdAnnualIncome',
    defaultMessage: 'Household Annual Income',
  },
  adults: {
    id: 'App.ConvertToApplicantModal.adults',
    defaultMessage: 'Number of Adults',
  },
  // Both counts spell out Required themselves: a field with helper text of its
  // own loses the one the Form adds for a required field.
  adultsHelperText: {
    id: 'App.ConvertToApplicantModal.adultsHelperText',
    defaultMessage: 'Required. Do not include foster adults and live-in aides',
  },
  minors: {
    id: 'App.ConvertToApplicantModal.minors',
    defaultMessage: 'Number of Minors',
  },
  minorsHelperText: {
    id: 'App.ConvertToApplicantModal.minorsHelperText',
    defaultMessage: 'Required. Do not include foster children',
  },
  selectedPrograms: {
    id: 'App.ConvertToApplicantModal.selectedPrograms',
    defaultMessage: 'Selected Program(s)',
  },
  atLeastOneProgram: {
    id: 'App.ConvertToApplicantModal.atLeastOneProgram',
    defaultMessage: 'At least one program must be selected.',
  },
  program: {
    id: 'App.ConvertToApplicantModal.program',
    defaultMessage: 'Program',
  },
  eligibility: {
    id: 'App.ConvertToApplicantModal.eligibility',
    defaultMessage: 'Eligibility',
  },
  incomeLevel: {
    id: 'App.ConvertToApplicantModal.incomeLevel',
    defaultMessage: 'Income level',
  },
  eligibilityPass: {
    id: 'App.ConvertToApplicantModal.eligibilityPass',
    defaultMessage: 'Pass',
  },
  eligibilityFail: {
    id: 'App.ConvertToApplicantModal.eligibilityFail',
    defaultMessage: 'Fail',
  },
  // The bands the income-level calculation answers with. Mapped rather than
  // rendered raw so a locale other than en can translate them; an unrecognised
  // band falls back to the API's own string.
  incomeLevelExtremelyLow: {
    id: 'App.ConvertToApplicantModal.incomeLevelExtremelyLow',
    defaultMessage: 'Extremely Low',
  },
  incomeLevelVeryLow: {
    id: 'App.ConvertToApplicantModal.incomeLevelVeryLow',
    defaultMessage: 'Very Low',
  },
  incomeLevelLow: {
    id: 'App.ConvertToApplicantModal.incomeLevelLow',
    defaultMessage: 'Low',
  },
  incomeLevelModerate: {
    id: 'App.ConvertToApplicantModal.incomeLevelModerate',
    defaultMessage: 'Moderate',
  },
  incomeLevelOverIncome: {
    id: 'App.ConvertToApplicantModal.incomeLevelOverIncome',
    defaultMessage: 'Over Income',
  },
  incomeLevelNotDetermined: {
    id: 'App.ConvertToApplicantModal.incomeLevelNotDetermined',
    defaultMessage: 'Not Determined',
  },
  incomeLevelUnavailable: {
    id: 'App.ConvertToApplicantModal.incomeLevelUnavailable',
    defaultMessage: 'Unavailable',
  },
  waitlistRequired: {
    id: 'App.ConvertToApplicantModal.waitlistRequired',
    defaultMessage: 'Waitlist Required',
  },
  waitlistRequiredTooltip: {
    id: 'App.ConvertToApplicantModal.waitlistRequiredTooltip',
    defaultMessage:
      'A green check marks a program that requires the household to join the waitlist.',
  },
  conventional: {
    id: 'App.ConvertToApplicantModal.conventional',
    defaultMessage: 'Conventional',
  },
  placeholder: {
    id: 'App.ConvertToApplicantModal.placeholder',
    defaultMessage: '---',
  },
  // Primary Applicant section
  submissionDateTime: {
    id: 'App.ConvertToApplicantModal.submissionDateTime',
    defaultMessage: 'Submission Date/Time',
  },
  editSubmissionDateTimeNoPermissionTooltip: {
    id: 'App.ConvertToApplicantModal.editSubmissionDateTimeNoPermissionTooltip',
    defaultMessage: 'You do not have permission to perform this action.',
  },
  invalidSubmissionDateTime: {
    id: 'App.ConvertToApplicantModal.invalidSubmissionDateTime',
    defaultMessage: 'Enter a valid date and time',
  },
  firstName: {
    id: 'App.ConvertToApplicantModal.firstName',
    defaultMessage: 'First Name',
  },
  middleName: {
    id: 'App.ConvertToApplicantModal.middleName',
    defaultMessage: 'Middle Name',
  },
  lastName: {
    id: 'App.ConvertToApplicantModal.lastName',
    defaultMessage: 'Last Name',
  },
  suffix: {
    id: 'App.ConvertToApplicantModal.suffix',
    defaultMessage: 'Suffix',
  },
  contactInformation: {
    id: 'App.ConvertToApplicantModal.contactInformation',
    defaultMessage: 'Contact Information',
  },
  phoneNumber: {
    id: 'App.ConvertToApplicantModal.phoneNumber',
    defaultMessage: 'Phone Number',
  },
  phoneType: {
    id: 'App.ConvertToApplicantModal.phoneType',
    defaultMessage: 'Phone Type',
  },
  emailAddress: {
    id: 'App.ConvertToApplicantModal.emailAddress',
    defaultMessage: 'Email Address',
  },
  emailType: {
    id: 'App.ConvertToApplicantModal.emailType',
    defaultMessage: 'Email Type',
  },
  dateOfBirth: {
    id: 'App.ConvertToApplicantModal.dateOfBirth',
    defaultMessage: 'Date of Birth',
  },
  gender: {
    id: 'App.ConvertToApplicantModal.gender',
    defaultMessage: 'Gender',
  },
  race: {
    id: 'App.ConvertToApplicantModal.race',
    defaultMessage: 'Race',
  },
  ethnicity: {
    id: 'App.ConvertToApplicantModal.ethnicity',
    defaultMessage: 'Ethnicity',
  },
  address: {
    id: 'App.ConvertToApplicantModal.address',
    defaultMessage: 'Address',
  },
  city: {
    id: 'App.ConvertToApplicantModal.city',
    defaultMessage: 'City',
  },
  state: {
    id: 'App.ConvertToApplicantModal.state',
    defaultMessage: 'State',
  },
  zipCode: {
    id: 'App.ConvertToApplicantModal.zipCode',
    defaultMessage: 'Zip Code',
  },
  // Units & Preferences section
  bedrooms: {
    id: 'App.ConvertToApplicantModal.bedrooms',
    defaultMessage: 'Bedroom(s) Selection',
  },
  floorPlan: {
    id: 'App.ConvertToApplicantModal.floorPlan',
    defaultMessage: 'Floor Plan',
  },
  noPreference: {
    id: 'App.ConvertToApplicantModal.noPreference',
    defaultMessage: 'No Preference',
  },
  requestAccommodation: {
    id: 'App.ConvertToApplicantModal.requestAccommodation',
    defaultMessage: 'Request Accommodation',
  },
  accommodationRequested: {
    id: 'App.ConvertToApplicantModal.accommodationRequested',
    defaultMessage: 'Accommodation Requested',
  },
  accessibleUnit: {
    id: 'App.ConvertToApplicantModal.accessibleUnit',
    defaultMessage: 'Accessible Unit',
  },
  displacement: {
    id: 'App.ConvertToApplicantModal.displacement',
    defaultMessage: 'Displacement',
  },
  preferences: {
    id: 'App.ConvertToApplicantModal.preferences',
    defaultMessage: 'Preferences',
  },
  // Fees & Deposits section
  applicationFees: {
    id: 'App.ConvertToApplicantModal.applicationFees',
    defaultMessage: 'Application Fees',
  },
  adminFees: {
    id: 'App.ConvertToApplicantModal.adminFees',
    defaultMessage: 'Admin Fees',
  },
  depositAlternative: {
    id: 'App.ConvertToApplicantModal.depositAlternative',
    defaultMessage: 'Deposit Alternative',
  },
  securityLedgerDeposit: {
    id: 'App.ConvertToApplicantModal.securityLedgerDeposit',
    defaultMessage: 'Security Ledger Deposit',
  },
  totalToBeCharged: {
    id: 'App.ConvertToApplicantModal.totalToBeCharged',
    defaultMessage: 'Total to be Charged',
  },
  programUnavailableTooltip: {
    id: 'App.ConvertToApplicantModal.programUnavailableTooltip',
    defaultMessage:
      'Not available for this Application Date. The waitlist accepts Application Dates {range}.',
  },
  applicationDateRangeBetween: {
    id: 'App.ConvertToApplicantModal.applicationDateRangeBetween',
    defaultMessage: 'from {start} through {end}',
  },
  applicationDateRangeFrom: {
    id: 'App.ConvertToApplicantModal.applicationDateRangeFrom',
    defaultMessage: 'from {start} through today',
  },
  applicationDateRangeUntilToday: {
    id: 'App.ConvertToApplicantModal.applicationDateRangeUntilToday',
    defaultMessage: 'up to today',
  },
  applicationDateRangeNone: {
    id: 'App.ConvertToApplicantModal.applicationDateRangeNone',
    defaultMessage: 'on no dates while it is closed',
  },
  waitlistClosedLead: {
    id: 'App.ConvertToApplicantModal.waitlistClosedLead',
    defaultMessage: 'Waitlist Closed:',
  },
  waitlistClosedBanner: {
    id: 'App.ConvertToApplicantModal.waitlistClosedBanner',
    defaultMessage:
      '{lead} The waitlist closed on {closeDate}. You may continue converting ' +
      'this prospect to an applicant. Program availability will be based on ' +
      'the Application Date entered below.',
  },
  waitlistClosedBannerAdd: {
    id: 'App.ConvertToApplicantModal.waitlistClosedBannerAdd',
    defaultMessage:
      '{lead} The waitlist closed on {closeDate}. You may continue adding ' +
      'this household to the waitlist. Program availability will be based on ' +
      'the Application Date entered below.',
  },
  waitlistClosedBannerReinstate: {
    id: 'App.ConvertToApplicantModal.waitlistClosedBannerReinstate',
    defaultMessage:
      '{lead} The waitlist closed on {closeDate}. You may continue ' +
      'reinstating this household. Program availability will be based on the ' +
      'Application Date below.',
  },
  waitlistClosedBannerEdit: {
    id: 'App.ConvertToApplicantModal.waitlistClosedBannerEdit',
    defaultMessage:
      '{lead} The waitlist closed on {closeDate}. You may continue editing ' +
      'this household. If you change the Application Date, program ' +
      'availability will be based on the new date.',
  },
});

export default messages;
